export default { "columns":4,
 "image":"modifiers.png",
 "imageheight":32,
 "imagewidth":64,
 "margin":0,
 "name":"modifiers",
 "spacing":0,
 "tilecount":8,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":2,
         "type":"cracks"
        }, 
        {
         "id":3,
         "type":"cracks"
        }, 
        {
         "id":6,
         "type":"cracks"
        }, 
        {
         "id":7,
         "type":"cracks"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};